import React from 'react';

export default function TemplateFilterDrawer({
  isOpen,
  filters,
  setFilters,
  onReset,
  T
}) {
  if (!isOpen) return null;

  const INDUSTRIES = [
    'Software Engineer', 'Data Scientist', 'Designer', 'Product Manager',
    'Investment Banker', 'Consultant', 'Lawyer', 'Student', 'Marketing Specialist'
  ];

  const COLORS = [
    { name: 'Blue', value: '#2563EB' },
    { name: 'Emerald', value: '#059669' },
    { name: 'Slate', value: '#475569' },
    { name: 'Purple', value: '#7C3AED' },
    { name: 'Cyan', value: '#0891b2' },
    { name: 'Red', value: '#8C1515' },
    { name: 'Rose', value: '#e11d48' },
    { name: 'Gold', value: '#D4AF37' },
    { name: 'Violet', value: '#a855f7' },
    { name: 'Charcoal', value: '#2f2f2f' }
  ];

  return (
    <div style={{
      background: T.cardBg,
      borderBottom: `1px solid ${T.borderMain}`,
      padding: '14px 20px',
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      animation: 'slideDown 0.2s ease-out'
    }}>
      {/* Search Sort row */}
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        {/* Industry */}
        <div style={{ flex: '1 1 120px' }}>
          <label style={{ fontSize: '8px', fontWeight: 800, color: T.textMuted, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Role / Industry</label>
          <select
            value={filters.industry}
            onChange={(e) => setFilters(prev => ({ ...prev, industry: e.target.value }))}
            style={{
              width: '100%',
              padding: '6px 8px',
              borderRadius: 6,
              background: T.pillBg,
              border: `1px solid ${T.borderCard}`,
              color: T.textSecondary,
              fontSize: '10px',
              outline: 'none'
            }}
          >
            <option value="all">All Industries</option>
            {INDUSTRIES.map(ind => (
              <option key={ind} value={ind}>{ind}</option>
            ))}
          </select>
        </div>

        {/* Complexity */}
        <div style={{ flex: '1 1 100px' }}>
          <label style={{ fontSize: '8px', fontWeight: 800, color: T.textMuted, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Complexity</label>
          <select
            value={filters.complexity}
            onChange={(e) => setFilters(prev => ({ ...prev, complexity: e.target.value }))}
            style={{
              width: '100%',
              padding: '6px 8px',
              borderRadius: 6,
              background: T.pillBg,
              border: `1px solid ${T.borderCard}`,
              color: T.textSecondary,
              fontSize: '10px',
              outline: 'none'
            }}
          >
            <option value="all">All Levels</option>
            <option value="easy">Easy (Clean Layout)</option>
            <option value="medium">Medium (Detailed)</option>
            <option value="advanced">Advanced (Visual)</option>
          </select>
        </div>

        {/* Sort By */}
        <div style={{ flex: '1 1 100px' }}>
          <label style={{ fontSize: '8px', fontWeight: 800, color: T.textMuted, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Sort By</label>
          <select
            value={filters.sortBy}
            onChange={(e) => setFilters(prev => ({ ...prev, sortBy: e.target.value }))}
            style={{
              width: '100%',
              padding: '6px 8px',
              borderRadius: 6,
              background: T.pillBg,
              border: `1px solid ${T.borderCard}`,
              color: T.textSecondary,
              fontSize: '10px',
              outline: 'none'
            }}
          >
            <option value="popular">Most Popular</option>
            <option value="newest">Newest Designs</option>
            <option value="ats">ATS Score (High to Low)</option>
          </select>
        </div>
      </div>

      {/* Colors selectors */}
      <div>
        <label style={{ fontSize: '8px', fontWeight: 800, color: T.textMuted, textTransform: 'uppercase', display: 'block', marginBottom: 6 }}>Color Theme</label>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
          <button
            onClick={() => setFilters(prev => ({ ...prev, color: 'all' }))}
            style={{
              fontSize: '8.5px',
              fontWeight: 700,
              padding: '2px 8px',
              borderRadius: 12,
              background: filters.color === 'all' ? 'var(--brand)' : T.pillBg,
              color: filters.color === 'all' ? '#fff' : T.textSecondary,
              border: 'none',
              cursor: 'pointer'
            }}
          >All</button>
          
          {COLORS.map(c => (
            <div
              key={c.name}
              onClick={() => setFilters(prev => ({ ...prev, color: c.name }))}
              style={{
                width: 14,
                height: 14,
                borderRadius: '50%',
                background: c.value,
                border: filters.color === c.name ? `2px solid ${T.textPrimary}` : `1px solid ${T.borderCard}`,
                cursor: 'pointer',
                boxShadow: filters.color === c.name ? `0 0 6px ${c.value}` : 'none',
                transition: 'all 0.15s'
              }}
              title={c.name}
            />
          ))}
        </div>
      </div>

      {/* Checkbox pills row */}
      <div style={{ display: 'flex', justifycontent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
        <div style={{ display: 'flex', gap: 14 }}>
          {/* Sidebar */}
          <label style={{ display: 'flex', alignItems: 'center', gap: 5, cursor: 'pointer', fontSize: '10px', color: T.textSecondary }}>
            <input
              type="checkbox"
              checked={filters.requireSidebar}
              onChange={(e) => setFilters(prev => ({ ...prev, requireSidebar: e.target.checked }))}
              style={{ accentColor: 'var(--brand)' }}
            />
            <span>Requires Sidebar</span>
          </label>
          
          {/* Photo */}
          <label style={{ display: 'flex', alignItems: 'center', gap: 5, cursor: 'pointer', fontSize: '10px', color: T.textSecondary }}>
            <input
              type="checkbox"
              checked={filters.requirePhoto}
              onChange={(e) => setFilters(prev => ({ ...prev, requirePhoto: e.target.checked }))}
              style={{ accentColor: 'var(--brand)' }}
            />
            <span>Supports Photo</span>
          </label>

          {/* Premium */}
          <label style={{ display: 'flex', alignItems: 'center', gap: 5, cursor: 'pointer', fontSize: '10px', color: T.textSecondary }}>
            <input
              type="checkbox"
              checked={filters.premiumOnly}
              onChange={(e) => setFilters(prev => ({ ...prev, premiumOnly: e.target.checked }))}
              style={{ accentColor: 'var(--brand)' }}
            />
            <span>Premium Only</span>
          </label>
        </div>

        <button
          onClick={onReset}
          style={{
            fontSize: '9px',
            fontWeight: 700,
            background: 'none',
            border: 'none',
            color: '#6366f1',
            cursor: 'pointer',
            padding: 0
          }}
        >
          Reset Filters
        </button>
      </div>
    </div>
  );
}
